<div class="excel-download" [ngClass]="{ 'excel-ar-download': current_lang === 'ar' }">
<!--- Dropdown option -->
  <div class="table-dropdown">
    <button class="btn-select-dropdown" [ngClass]="{'select-dropdown-proptype': dropDownOption?.showSelectedValue}" [matMenuTriggerFor]="menu" [disabled]="LockReport">
      <ng-container>
       <ng-container>{{ "reports.show_value_in" | translate }} :</ng-container>
        <span>{{
          selectedRadio
          ? ("reports." + selectedRadio | translate)
          : ("reports." + dropDownOption?.default | translate)
          }}</span>
      </ng-container>    
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
    <mat-menu #menu="matMenu" [xPosition]="current_lang === 'ar' ? 'after' : 'before'" class="table-dropdown-menu">
      <div (click)="$event.stopPropagation()">
        <h5>
          {{ 'reports.show_price_in' | translate }}
        </h5>
        <mat-radio-group *ngIf="!dropDownOption?.reportType" aria-label="Select an option">
          <ng-container *ngFor="let option of dropDownOption?.data; let i = index">
            <mat-radio-button (change)="selectRadioValue(option.id, option.value)" value="{{ option.id }}"
              [checked]="option.id === dropDownOption?.default">{{ "reports." + option.value | translate
              }}</mat-radio-button>
          </ng-container>
        </mat-radio-group>

      </div>
    </mat-menu>
  </div>
    <!--- Down load icon -->
    <div class="download-excel-outer" *ngIf="
      tableData?.length !== 0 &&
      tableData &&
      allowExcelDownload
    ">
        <button class="download_excel" [disabled]="LockReport" *ngIf="!downloadLoading" (click)="downloadExcel()"
            matTooltip="{{ 'reports.download_excel' | translate }}" matTooltipPosition="above"><img *ngIf="!LockReport"
                src="../../../../../../assets/images/excel-icon.svg" />
            <img *ngIf="LockReport" src="../../../../../../assets/images/excel-icon-disable.svg" /></button>
        <span *ngIf="downloadLoading"><mat-spinner class="download-spinner"></mat-spinner></span>
    </div>
    <!--- Dropdown option -->
</div>

<div class="main-table">
    <table class="table" matSort (matSortChange)="onSortTable($event)">
        <thead>
            <tr>
                <ng-container *ngFor="let tableColumn of tableColumns">

                    <!-- Conditionally render <th> with or without mat-sort-header -->
                    <th *ngIf="tableColumn.isSortable; else noSort" mat-sort-header="{{ tableColumn.header }}"
                        [class.custom-bg-th]="tableColumn.border">

                        <ng-container *ngIf="tableColumn?.recordType; else otherColumn">
                                <span class="header_label record_type">
                                    {{ tableColumn?.columnName | translate }}
                                    <span class="">{{ tableColumn?.symbol | reportDataValueType }}</span>
                                    <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                                </span>
                        </ng-container>

                        <ng-template #otherColumn>
                                <span class="header_label">
                                    {{ tableColumn?.columnName | translate }}
                                    <span class="text-transform-normal">{{ tableColumn?.symbol | reportDataValueType }}</span>
                                </span>
                        </ng-template>
                    </th>

                    <!-- <th> without mat-sort-header -->
                    <ng-template #noSort>
                        <th [class.custom-bg-th]="tableColumn.border">
                            <ng-container *ngIf="tableColumn?.recordType; else otherColumnNoSort">
                                    <span class="header_label record_type">
                                        {{ tableColumn?.columnName | translate }}
                                        <span class="">{{ tableColumn?.symbol | reportDataValueType }}</span>
                                        <span class="record_type-text">({{ "reports.record_type" | translate }})</span>
                                    </span>
                            </ng-container>

                            <ng-template #otherColumnNoSort>
                                    <span class="header_label">
                                        {{ tableColumn?.columnName | translate }}
                                        <span class="text-transform-normal">{{ tableColumn?.symbol |
                                            reportDataValueType }}</span>
                                    </span>
                            </ng-template>
                        </th>
                    </ng-template>

                </ng-container>
            </tr>

        </thead>
        <tbody>
            <tr *ngFor="let element of tableData; let i = index"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                (click)="setExpadndColor(i)" [@detailExpand]="element.isOpen === 1 ? 'collapsed' : 'expanded'"
                [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor"
                [ngClass]="(expandedElement === element && !element['outlier'] ? 'example-expanded-row':'')"
                [ngClass]="{ hideTable: !showLoader }"
                [ngClass]="{'tr-parent': element.isParent, 'tr-child': !element.isParent}"
                [class.expand-hide]="element.isOpen === 1" [ngClass]="{'blur-content': element['NODATA']}">

                <td>
                    <div class="column-data align-items-center position-relative">
                        <!-- Expand Icon -->
                        <div class="expand-icon" [class.d-none]="!element.isDetail">
                            <mat-icon (click)="isChildOpen(element, i);
                            expandedElement =
                              expandedElement === element ? null : element
                          ">{{
                                expandedElement === element
                                ? "arrow_drop_down"
                                : current_lang === "ar"
                                ? "arrow_left"
                                : "arrow_right"
                                }}</mat-icon>
                        </div>
                        <div class="tooltip showonmap-column">
                            <!-- Column Name Text -->
                              <span class="column_entry" [attr.title]="element?.property_name"
                                (click)="panToMap(element, tableColumns[0].field, i, 'showOnMap', true, element?.is_layout)"
                                [ngClass]="{'link_item': (element?.lat && tableColumns[0]?.showOnMap && tableColumns[0]?.isAnchor && element.isParent)}">
                                {{element?.property_name }}
                                <ng-container *ngIf="!element.isParent"><span class="td-sqmtext">({{sqmUnit}})</span></ng-container>
                            </span>
                          
                        </div>
                         <span *ngIf="element.isParent" class="show_on_map"
                                [ngClass]="{'clicked_item': selectedIndex === ('' + goToPageNumber + i)}"
                                (click)="panToMap(element, tableColumns[0].field, i, 'showOnMap')"
                                matTooltip="{{'reports.show_on_map' | translate}}">
                                <mat-icon svgIcon="location" class="icon" *ngIf="!element?.is_layout"></mat-icon>
                                <mat-icon svgIcon="floorLayoutIcon" class="icon" *ngIf="element?.is_layout"></mat-icon>
                            </span>
                            <!-- Show On Map Loader -->
                            <span class="tenent_map_icon loader__"
                                *ngIf="(element?.lat || element?.tenants_lat_lon) && selectedIndex === ('' + goToPageNumber + i) && tenantLoading"
                                [ngClass]="{'clicked_item': tenantLoading && selectedIndex === ('' + goToPageNumber + i)}"><mat-spinner
                                    class="download-spinner"></mat-spinner></span>
                    </div>
                </td>
                <ng-container *ngIf="selectedRadio == 'Range'">
                    <td matTooltip="{{element?.all_floor_avg}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.all_floor_avg ? false: true">{{element?.all_floor_range ?? '-'}}</td>               
                    <td matTooltip="{{element?.lower_ground_avg}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.lower_ground_avg ? false: true">{{element?.lower_ground_range ?? '-'}}</td>
                    <td matTooltip="{{element?.ground_avg}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.ground_avg ? false: true">{{element?.ground_range  ?? '-'}}</td>
                    <td matTooltip="{{element?.first_floor_avg}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.first_floor_avg ? false: true">{{element?.first_floor_range  ?? '-'}}</td>
                    <td matTooltip="{{element?.second_floor_avg}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.second_floor_avg ? false: true">{{element?.second_floor_range  ?? '-'}}</td>
                    <td matTooltip="{{element?.third_floor_avg}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.third_floor_avg ? false: true">{{element?.third_floor_range  ?? '-'}}</td>
                    <td matTooltip="{{element?.higher_floor_avg}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.higher_floor_avg ? false: true">{{element?.higher_floor_range  ?? '-'}}</td>
                    <td>{{element?.neigh_name  ?? '-'}}</td>
                    <td>{{element?.property_uid  ?? '-'}}</td>
                    <td>{{element?.property_sub_cat  ?? '-'}}</td>
                </ng-container>
                 <ng-container *ngIf="selectedRadio == 'Average'">
                    <td matTooltip="{{element?.all_floor_range}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.all_floor_range ? false: true">{{(element?.all_floor_avg | number: '1.0-1') ?? '-'}}</td> 
                    <td matTooltip="{{element?.lower_ground_range}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.lower_ground_range ? false: true">{{(element?.lower_ground_avg | number: '1.0-1') ?? '-'}}</td>
                    <td matTooltip="{{element?.ground_range}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.ground_range ? false: true">{{(element?.ground_avg | number: '1.0-1')  ?? '-'}}</td>
                    <td matTooltip="{{element?.first_floor_range}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.first_floor_range ? false: true">{{(element?.first_floor_avg | number: '1.0-1')  ?? '-'}}</td>
                    <td matTooltip="{{element?.second_floor_range}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.second_floor_range ? false: true">{{(element?.second_floor_avg | number: '1.0-1')  ?? '-'}}</td>
                    <td matTooltip="{{element?.third_floor_range}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.third_floor_range ? false: true">{{(element?.third_floor_avg | number: '1.0-1')  ?? '-'}}</td>
                    <td matTooltip="{{element?.higher_floor_range}} {{CurrencyCodeSQM}}" [matTooltipDisabled]="element?.higher_floor_range ? false: true">{{(element?.higher_floor_avg | number: '1.0-1')  ?? '-'}}</td>
                    <td>{{element?.neigh_name  ?? '-'}}</td>
                    <td>{{element?.property_uid  ?? '-'}}</td>
                    <td>{{element?.property_sub_cat  ?? '-'}}</td>
                </ng-container>
               
            </tr>
            <tr *ngIf="!showLoader" style="height: auto;" class="loader-tr">
                <td style="padding: 0;" [attr.colspan]="tableColumns?.length">
                    <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
                </td>
            </tr>
        </tbody>
    </table>
    <!--- No Record Found -->
    <div class="data_unavail" *ngIf="(tableData?.length === 0 || !tableData) && showLoader">
        <span>
            {{"reports.dataComingSoon" | translate}}
        </span>
    </div>
    <!-- Table content blur start -->
    <div class="lock-table-row" *ngIf="LockReport">
        <img src="../../../../../../assets/images/Lock.png" alt="">
    </div>
</div>
<!--- Pagination -->
<div class="pagination-wrapper pagination-showing-count"
    *ngIf="tableData?.length !== 0 && tableData && !hidePagination">
    <ng-container *ngIf="show_step_count">
        <p *ngIf="!LockReport" [class.showingrecord-margin]="dataLength > 2">
            {{ "reports.Showing" | translate }} {{ startIndex }}
            {{ "reports.to" | translate }} {{ endIndex }}
            {{ "reports.outOf" | translate }}
            {{ dataLength | internationalNumber }}
            {{ "reports.records" | translate}}
        </p>
    </ng-container>
    <p *ngIf="LockReport" class="pb-2">
        <span class="contact-sale" (click)="openContactSales()">{{'contactSales' | translate }}</span>
        {{'to_unlock' | translate }} <ng-container *ngIf="dataLength > 3"> {{(dataLength
            - 3) | internationalNumber }} {{'rows_more'| translate}}</ng-container> <ng-container
            *ngIf="dataLength <= 3">{{'more_rows'|
            translate}}</ng-container>.
    </p>

    <mat-paginator *ngIf="dataLength > 20" [disabled]="!showLoader || LockReport" class="default-pagination"
        [length]="dataLength" [pageSize]="20" [pageSizeOptions]="[5, 10, 15, 25, 100]" [showFirstLastButtons]="true"
        (page)="onPageChange($event)" [hidePageSize]="true">
    </mat-paginator>

    <!-- Pagination input -->
    <div class="go-to-page d-flex align-items-center" *ngIf="dataLength > 20">
        <input class="go-to-page-input" type="number" [(ngModel)]="goToPageNumber" (change)="onGoToPage()"
            [disabled]="totalPages === 1 || !showLoader || LockReport" />
        <span class="oftext">of</span>
        <span>{{ totalPages }}</span>
    </div>
</div>

<!--- data cleaned Text -->
<div class="dataCleaned">
    <span>
        <ng-container *ngIf="showEstaterText">{{
            "reports.dataCleaned" | translate
            }}</ng-container>
    </span>

</div>